/*
环境配置 · develop(部署产物)。类型与字段语义见 ./environment.type.ts。

一套产物部署到全部 develop.<tenant>.levvel.cloud —— 租户由请求 Host 决定:部署层 APISIX
把租户域名下的 /api/v1/* 整体路由到该租户的 module BE(包括 /api/v1/configuration;
rpms #115 `598153a` 把这条路由从 ufs 移进各租户 module,连 ufs 的 configuration.proto
一起删,module 的 handler 不读 Host、直接返回自己 config.yaml 的投影。⚠️ 不要再按路径
把它分给 ufs,那个地址已经 404)。故本文件不含任何租户信息。

- configSource: 'live' —— develop 出的是部署产物,打真 configuration 端点。
- ufsApiHost 不设 —— resolveUfsHost() 按当前 host 派生
  (develop.<tenant>.levvel.cloud → develop.ufs.levvel.cloud)。ufs 只剩 SSO/SLO,
  不在 /api 的分发范围内。
*/
import { Environment } from './environment.type';

export const environment: Environment = {
  configSource: 'live',
  apiHost: '/api',
};

/* ──────────────────────── 遗产形状(2026-08-13 前)────────────────────────
旧写法套用的是遗产 Environment 类型(src/types/system.type.ts),交的税与 local.ts
同款:production: true 只为喂 index.tsx 那一个 OR(收敛为 configSource);
regionCode 是类型 required 被迫填的假值,零消费(真值走运行时 config.style)。

import { Environment } from '@/types/system.type';

export const environment: Environment = {
  production: true,
  apiHost: '/api',
  regionCode: ['+45', '+86'],
};
─────────────────────────────────────────────────────────────────────────── */
